import styled from 'styled-components';
import { defaultTheme } from '../core/theme';

export const H2 = styled.h2`
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.2;
  color: ${defaultTheme.colors.black};
`;
